import React from 'react';
import './CheckboxInput.scss';
import {constructClassNames} from "../../helpers/helpers";

const CheckboxInput = (
  { name, value, onChange, label, required, error, disabled, index, noMargin }
) => {
  const classes = [
    {name: 'noMargin', condition: !!noMargin},
  ];

  const labelClasses = [
    {name: 'inputLabelDisabled', condition: !!disabled},
  ];

  return (
    <div className={constructClassNames('CheckboxInput', classes)}>
      <input
        id={index ? name + index : name}
        type='checkbox'
        onChange={e => onChange(name, e.target.checked, false, true, 'checkbox')}
        checked={value}
        disabled={disabled}
      />
      {!!label && (
        <label className={constructClassNames('inputLabel', labelClasses)} htmlFor={index ? name + index : name}>
          {label}{required ? '*' : ''}
        </label>
      )}
    </div>
  );
}

export default CheckboxInput;
